import Devices from "../Devices/Devices"

const UsbDisabledDevices = () => (
  <Devices
    preset={{ usb: "Disabled" }}
    locked={["usb"]}
    title="USB disabled devices"
  />
)

export default UsbDisabledDevices
